var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFlashAuto = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .flash-auto-class-a {\n        fill: none !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5052",
    "data-name": "Group 5052",
    transform: "translate(-490 -986)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2301",
    className: "flash-auto-class-a",
    "data-name": "Rectangle 2301",
    width: 24,
    height: 24,
    transform: "translate(490 986)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5049",
    "data-name": "Group 5049",
    transform: "translate(364.589 844.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-flash-auto",
    "data-name": "Icon material-flash-auto",
    d: "M16.68,2H15.572L13.8,8.408h1.052l.388-1.424h1.772L17.4,8.408h1.052ZM15.489,6.023l.637-2.6.637,2.6Z",
    transform: "translate(126.571 141.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-flash",
    "data-name": "Icon ionic-ios-flash",
    d: "M17.077,10.069H12.248l2.339-8.341a.18.18,0,0,0-.321-.152l-8.2,10.751a.376.376,0,0,0,.281.6h4.829L8.838,21.267a.18.18,0,0,0,.321.152l8.2-10.747A.381.381,0,0,0,17.077,10.069Z",
    transform: "translate(125.414 141.754)",
    fill: "#fff"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFlashAuto);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/FlashAuto.a488eec9dcfc8d69d0638be496cc35ce.svg";